import { FC, ReactNode } from 'react'
import { SideoverState } from '@/states'
import { useCapture } from '@/hooks'
import { ClipboardValidation } from '@/helpers'
import { Captured, Uncaptured } from '@/ui/components'

const Clipboard: FC = (): ReactNode => {
    useCapture()

    const { Errors, Form, Loading } = SideoverState()

    const validation: ValidationFunctionObjectReturnTypes = ClipboardValidation(Form?.Clipboard)

    return (
        <div className='select-none flex w-full flex-col' style={Loading ? { opacity: '0.75', pointerEvents: 'none' } : { opacity: '1', pointerEvents: 'auto' }}>
            <label className='select-none block mb-1 text-[13px] font-medium text-[#97999b]'>
                Component

                <span className='text-red-400 ml-1 text-[12px]'>
                    *
                </span>
            </label>

            <div className='flex flex-col items-center justify-center w-full h-44 border-2 border-[#424242] border-dashed rounded-md bg-[#4A4A4A] cursor-not-allowed'>
                <Uncaptured />
                <Captured />
            </div>

            <p style={validation?.error && Errors?.Clipboard ? { opacity: '1' } : { opacity: '0' }} className='text-xs h-6 mt-[2px] ml-[2px] text-red-500 transition-all duration-500 ease-in-out'>
                {validation?.message}
            </p>
        </div>
    )
}

export default Clipboard
